import { render, staticRenderFns } from "./unit_module_completion.vue?vue&type=template&id=719f9ba2&"
import script from "./unit_module_completion.vue?vue&type=script&lang=js&"
export * from "./unit_module_completion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports